import { useCallback, useContext, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { useTrainingCourses } from "../../../../../hooks/useTrainingCourses"
import { UserContext } from "../../../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../models/Authorization"
import { TrainingGet } from "../../../../models/Training"
import { TrainingCourseGet } from "../../../../models/TrainingCourse"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function TrainingCourses(props: { readonly training: TrainingGet }) {
  const { trainingId } = useParams()
  const { training } = props
  const { user } = useContext(UserContext)
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()
  const { trainingCourses, isLoadingTrainingCourses } = useTrainingCourses(trainingId)

  const cols = [
    { field: "position", headerName: "Position" },
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/trainings/${trainingId}/courses`,
    },
    { field: "type", headerName: "Type" },
    { field: "duration", headerName: "Duration" },
  ]

  const rows = trainingCourses.map((course: TrainingCourseGet) => ({
    id: course.id,
    position: course.position,
    name: course.name,
    type: course.type,
    duration: course.duration,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/trainings/${trainingId}/courses/create`}
        feature={DimaFeatureShortNameEnum.TM}
        applicationId={training.application.id}
      />
    ),
    [trainingId, training.application.id]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/trainings/${trainingId}/courses/${row.id}`))
      }
    },
    [trainingId, requestDelete]
  )

  const canDelete =
    !!user &&
    hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      training.application.id,
      DimaFeatureShortNameEnum.TM,
      AccessLevel.Write
    )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingTrainingCourses}
        toolbar={toolbar}
        actionItems={
          canDelete
            ? [{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]
            : []
        }
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
